import { AxiosError } from 'axios';
import { useApi } from '../../services/api';

interface ISubmitInvoiceXmlResult {
  success: boolean;
  message?: string;
}

export const useSubmitInvoiceXml = () => {
  const { api, paths } = useApi();

  const submitInvoiceXml = async (file: File): Promise<ISubmitInvoiceXmlResult> => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      await api.post(paths.invoices.uploadXml, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          userFunctionKey: '74ed9c319ca41440600efb4aa65bbeed'
        }
      });
      return { success: true };
    } catch (error) {
      const axiosError = error as AxiosError;
      const message = (axiosError.response?.data as { message?: string })?.message;
      return { success: false, message };
    }
  };

  return { submitInvoiceXml };
};
